import { default as indexoTnn630B7ZMeta } from "/app/browser/pages/account/ads-and-search/index.vue?macro=true";
import { default as deletedGB7R3IMFJcMeta } from "/app/browser/pages/account/deleted.vue?macro=true";
import { default as forgot_45passwordomLPRIyligMeta } from "/app/browser/pages/account/forgot-password.vue?macro=true";
import { default as indexnlBtzRDVeBMeta } from "/app/browser/pages/account/index.vue?macro=true";
import { default as credentialsKxj59EL0vRMeta } from "/app/browser/pages/account/settings/credentials.vue?macro=true";
import { default as indexkVbNvFcOcaMeta } from "/app/browser/pages/account/settings/index.vue?macro=true";
import { default as notificationsmkZafOqobsMeta } from "/app/browser/pages/account/settings/notifications.vue?macro=true";
import { default as personal_45detailsxWX8uI00SAMeta } from "/app/browser/pages/account/settings/personal-details.vue?macro=true";
import { default as privacyFS9CX2zMCLMeta } from "/app/browser/pages/account/settings/privacy.vue?macro=true";
import { default as subscriptionfV3Mhd4EWOMeta } from "/app/browser/pages/account/settings/subscription.vue?macro=true";
import { default as indexJsJvXSWZIuMeta } from "/app/browser/pages/account/subscription/index.vue?macro=true";
import { default as _91confirmationCode_93y5nGKexYCbMeta } from "/app/browser/pages/confirm/password/[userId]/[confirmationCode].vue?macro=true";
import { default as matchesBKwChunUROMeta } from "/app/browser/pages/dashboard/matches.vue?macro=true";
import { default as faqvLyYP9V999Meta } from "/app/browser/pages/faq.vue?macro=true";
import { default as editMzYk8O0RgDMeta } from "/app/browser/pages/housing/edit.vue?macro=true";
import { default as photosKhkcBrAZ6TMeta } from "/app/browser/pages/housing/photos.vue?macro=true";
import { default as imprint4jwvYe1OhtMeta } from "/app/browser/pages/imprint.vue?macro=true";
import { default as loginbIud4FrU2ZMeta } from "/app/browser/pages/login.vue?macro=true";
import { default as logoutgt2uznbN9SMeta } from "/app/browser/pages/logout.vue?macro=true";
import { default as _91_91intermediateUserGuid_93_93P1qpsZOHojMeta } from "/app/browser/pages/messaging/chat/[targetUserGuid]/[[intermediateUserGuid]].vue?macro=true";
import { default as privacyvcJIMAhYAqMeta } from "/app/browser/pages/privacy.vue?macro=true";
import { default as registrierenOBuaYLzIK2Meta } from "/app/browser/pages/registrieren.vue?macro=true";
import { default as multi_45portal_45publishing3YEMBoJi50Meta } from "/app/browser/pages/sale/multi-portal-publishing.vue?macro=true";
import { default as willkommen6LkI6f96uEMeta } from "/app/browser/pages/willkommen.vue?macro=true";
import { default as offerZSrZFckVCaMeta } from "~/components/pages/offer.vue?macro=true";
import { default as search0uYrfUsCGiMeta } from "~/components/pages/search.vue?macro=true";
import { default as privacyEi1SVgYCUiMeta } from "~/pages/privacy.vue?macro=true";
import { default as imprintAygQYYcmhqMeta } from "~/pages/imprint.vue?macro=true";
import { default as contactf7WDzWPbSTMeta } from "~/components/pages/ring-swap/contact?macro=true";
import { default as all_45chatsSXPHa6s51BMeta } from "~/components/pages/ring-swap/all-chats?macro=true";
import { default as _91_91intermediateUserGuid_93_93hAolaJcaeQMeta } from "~/pages/messaging/chat/[targetUserGuid]/[[intermediateUserGuid]].vue?macro=true";
import { default as advanced_45navigationULyg0XqodOMeta } from "~/components/pages/advanced-navigation.vue?macro=true";
import { default as _404BNNzHj7OyYMeta } from "~/components/error/404.vue?macro=true";
import { default as _500kxilv8kd94Meta } from "~/components/error/500.vue?macro=true";
import { default as pagesYLEV5L26GbMeta } from "/app/browser/modules/city-pages/pages.vue?macro=true";
export default [
  {
    name: "account-ads-and-search",
    path: "/account/ads-and-search",
    meta: indexoTnn630B7ZMeta || {},
    component: () => import("/app/browser/pages/account/ads-and-search/index.vue")
  },
  {
    name: "account-deleted",
    path: "/account/deleted",
    component: () => import("/app/browser/pages/account/deleted.vue")
  },
  {
    name: "account-forgot-password",
    path: "/account/forgot-password",
    component: () => import("/app/browser/pages/account/forgot-password.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexnlBtzRDVeBMeta || {},
    component: () => import("/app/browser/pages/account/index.vue")
  },
  {
    name: "account-settings-credentials",
    path: "/account/settings/credentials",
    meta: credentialsKxj59EL0vRMeta || {},
    component: () => import("/app/browser/pages/account/settings/credentials.vue")
  },
  {
    name: "account-settings",
    path: "/account/settings",
    meta: indexkVbNvFcOcaMeta || {},
    component: () => import("/app/browser/pages/account/settings/index.vue")
  },
  {
    name: "account-settings-notifications",
    path: "/account/settings/notifications",
    meta: notificationsmkZafOqobsMeta || {},
    component: () => import("/app/browser/pages/account/settings/notifications.vue")
  },
  {
    name: "account-settings-personal-details",
    path: "/account/settings/personal-details",
    meta: personal_45detailsxWX8uI00SAMeta || {},
    component: () => import("/app/browser/pages/account/settings/personal-details.vue")
  },
  {
    name: "account-settings-privacy",
    path: "/account/settings/privacy",
    meta: privacyFS9CX2zMCLMeta || {},
    component: () => import("/app/browser/pages/account/settings/privacy.vue")
  },
  {
    name: "account-settings-subscription",
    path: "/account/settings/subscription",
    meta: subscriptionfV3Mhd4EWOMeta || {},
    component: () => import("/app/browser/pages/account/settings/subscription.vue")
  },
  {
    name: "account-subscription",
    path: "/account/subscription",
    meta: indexJsJvXSWZIuMeta || {},
    component: () => import("/app/browser/pages/account/subscription/index.vue")
  },
  {
    name: "confirm-password-userId-confirmationCode",
    path: "/confirm/password/:userId()/:confirmationCode()",
    component: () => import("/app/browser/pages/confirm/password/[userId]/[confirmationCode].vue")
  },
  {
    name: "dashboard-matches",
    path: "/dashboard/matches",
    meta: matchesBKwChunUROMeta || {},
    component: () => import("/app/browser/pages/dashboard/matches.vue")
  },
  {
    name: "faq",
    path: "/faq",
    meta: faqvLyYP9V999Meta || {},
    component: () => import("/app/browser/pages/faq.vue")
  },
  {
    name: "housing-edit",
    path: "/housing/edit",
    meta: editMzYk8O0RgDMeta || {},
    component: () => import("/app/browser/pages/housing/edit.vue")
  },
  {
    name: "housing-photos",
    path: "/housing/photos",
    meta: photosKhkcBrAZ6TMeta || {},
    component: () => import("/app/browser/pages/housing/photos.vue")
  },
  {
    name: "imprint",
    path: "/imprint",
    component: () => import("/app/browser/pages/imprint.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginbIud4FrU2ZMeta || {},
    component: () => import("/app/browser/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutgt2uznbN9SMeta || {},
    component: () => import("/app/browser/pages/logout.vue")
  },
  {
    name: "messaging-chat-targetUserGuid-intermediateUserGuid",
    path: "/messaging/chat/:targetUserGuid()/:intermediateUserGuid?",
    meta: _91_91intermediateUserGuid_93_93P1qpsZOHojMeta || {},
    component: () => import("/app/browser/pages/messaging/chat/[targetUserGuid]/[[intermediateUserGuid]].vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/app/browser/pages/privacy.vue")
  },
  {
    name: "registrieren",
    path: "/registrieren",
    meta: registrierenOBuaYLzIK2Meta || {},
    component: () => import("/app/browser/pages/registrieren.vue")
  },
  {
    name: "sale-multi-portal-publishing",
    path: "/sale/multi-portal-publishing",
    meta: multi_45portal_45publishing3YEMBoJi50Meta || {},
    component: () => import("/app/browser/pages/sale/multi-portal-publishing.vue")
  },
  {
    name: "willkommen",
    path: "/willkommen",
    meta: willkommen6LkI6f96uEMeta || {},
    component: () => import("/app/browser/pages/willkommen.vue")
  },
  {
    name: "housing-show-wohnung-mieten",
    path: "/wohnung-mieten/:city/:area?/:slug",
    meta: { ...(offerZSrZFckVCaMeta || {}), ...{"showMobileNavigation":true} },
    component: () => import("~/components/pages/offer.vue")
  },
  {
    name: "housing-show-wohnung-kaufen",
    path: "/wohnung-kaufen/:city/:area?/:slug",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/pages/offer.vue")
  },
  {
    name: "housing-show-wg-zimmer-mieten",
    path: "/wg-zimmer-mieten/:city/:area?/:slug",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/pages/offer.vue")
  },
  {
    name: "housing-show-haus-mieten",
    path: "/haus-mieten/:city/:area?/:slug",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/pages/offer.vue")
  },
  {
    name: "housing-show-haus-kaufen",
    path: "/haus-kaufen/:city/:area?/:slug",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/pages/offer.vue")
  },
  {
    name: "housing-search-wohnung-mieten",
    path: "/suche/wohnung-mieten/:city?/:area?/:slug?",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/pages/search.vue")
  },
  {
    name: "housing-search-wohnung-kaufen",
    path: "/suche/wohnung-kaufen/:city?/:area?/:slug?",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/pages/search.vue")
  },
  {
    name: "housing-search-wg-zimmer-mieten",
    path: "/suche/wg-zimmer-mieten/:city?/:area?/:slug?",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/pages/search.vue")
  },
  {
    name: "housing-search-haus-mieten",
    path: "/suche/haus-mieten/:city?/:area?/:slug?",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/pages/search.vue")
  },
  {
    name: "housing-search-haus-kaufen",
    path: "/suche/haus-kaufen/:city?/:area?/:slug?",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/pages/search.vue")
  },
  {
    name: "suche",
    path: "/suche/:city?/:area?/:slug?",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/pages/search.vue")
  },
  {
    path: "/chat",
    name: "chat",
    redirect: {"name":"messaging-dashboard"}
  },
  {
    path: "/",
    name: "index",
    redirect: {"name":"dashboard-matches"}
  },
  {
    path: "/dashboard",
    name: "dashboard",
    redirect: {"name":"account-ads-and-search"}
  },
  {
    name: "privacy",
    path: "/datenschutz",
    meta: {"showMobileNavigation":true},
    component: () => import("~/pages/privacy.vue")
  },
  {
    name: "imprint",
    path: "/impressum",
    meta: {"showMobileNavigation":true},
    component: () => import("~/pages/imprint.vue")
  },
  {
    name: "ring-swap-contact",
    path: "/ring-swap/contact",
    meta: {"middleware":["auth"],"showMobileNavigation":false,"layout":"no-header-footer"},
    component: () => import("~/components/pages/ring-swap/contact")
  },
  {
    name: "ring-swap-all-chats",
    path: "/ring-swap/all-chats",
    meta: {"middleware":["auth"],"showMobileNavigation":false,"layout":"no-header-footer"},
    component: () => import("~/components/pages/ring-swap/all-chats")
  },
  {
    name: "messaging-chat",
    path: "/messaging/chat/:targetUserGuid?/:intermediateUserGuid?",
    meta: _91_91intermediateUserGuid_93_93hAolaJcaeQMeta || {},
    component: () => import("~/pages/messaging/chat/[targetUserGuid]/[[intermediateUserGuid]].vue")
  },
  {
    name: "messaging-dashboard",
    path: "/messaging/dashboard",
    meta: {"middleware":["auth"],"showMobileNavigation":true},
    component: () => import("~/pages/messaging/chat/[targetUserGuid]/[[intermediateUserGuid]].vue")
  },
  {
    path: "/dashboard/liked",
    name: "dashboard-liked",
    redirect: "/dashboard/matches?status=watchlist"
  },
  {
    path: "/dashboard/interested",
    name: "dashboard-interested",
    redirect: "/dashboard/matches?status=otherFullInterest"
  },
  {
    name: "advanced-navigation",
    path: "/advanced/navigation",
    meta: {"middleware":["auth"],"showMobileNavigation":true},
    component: () => import("~/components/pages/advanced-navigation.vue")
  },
  {
    name: "custom-404",
    path: "/:pathMatch(.*)*",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/error/404.vue")
  },
  {
    name: "custom-500",
    path: "/500",
    meta: {"showMobileNavigation":true},
    component: () => import("~/components/error/500.vue")
  },
  {
    name: "berlin",
    path: "/berlin/",
    meta: {"cityPage":{"name":"berlin","countryName":"germany","locationIds":{"regions":[],"cities":[3806],"areas":[]},"searchUrl":"/suche/wohnung-mieten/berlin?housingType=1&locationIds%5Bcities%5D=3806"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "hamburg",
    path: "/hamburg/",
    meta: {"cityPage":{"name":"hamburg","countryName":"germany","locationIds":{"regions":[],"cities":[4703],"areas":[]},"searchUrl":"/suche/wohnung-mieten/hamburg?housingType=1&locationIds%5Bcities%5D=4703"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "muenchen",
    path: "/muenchen/",
    meta: {"cityPage":{"name":"münchen","countryName":"germany","locationIds":{"regions":[],"cities":[2326],"areas":[]},"searchUrl":"/suche/wohnung-mieten/münchen?housingType=1&locationIds%5Bcities%5D=2326"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "münchen",
    path: "/m%C3%BCnchen/",
    meta: {"cityPage":{"name":"münchen","countryName":"germany","locationIds":{"regions":[],"cities":[2326],"areas":[]},"searchUrl":"/suche/wohnung-mieten/münchen?housingType=1&locationIds%5Bcities%5D=2326"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "koeln",
    path: "/koeln/",
    meta: {"cityPage":{"name":"köln","countryName":"germany","locationIds":{"regions":[],"cities":[8072],"areas":[]},"searchUrl":"/suche/wohnung-mieten/köln?housingType=1&locationIds%5Bcities%5D=8072"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "köln",
    path: "/k%C3%B6ln/",
    meta: {"cityPage":{"name":"köln","countryName":"germany","locationIds":{"regions":[],"cities":[8072],"areas":[]},"searchUrl":"/suche/wohnung-mieten/köln?housingType=1&locationIds%5Bcities%5D=8072"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "frankfurt-am-main",
    path: "/frankfurt-am-main/",
    meta: {"cityPage":{"name":"frankfurt am main","countryName":"germany","locationIds":{"regions":[],"cities":[4759],"areas":[]},"searchUrl":"/suche/wohnung-mieten/frankfurt-am-main?housingType=1&locationIds%5Bcities%5D=4759"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "stuttgart",
    path: "/stuttgart/",
    meta: {"cityPage":{"name":"stuttgart","countryName":"germany","locationIds":{"regions":[],"cities":[1056],"areas":[]},"searchUrl":"/suche/wohnung-mieten/stuttgart?housingType=1&locationIds%5Bcities%5D=1056"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "duesseldorf",
    path: "/duesseldorf/",
    meta: {"cityPage":{"name":"düsseldorf","countryName":"germany","locationIds":{"regions":[],"cities":[7960],"areas":[]},"searchUrl":"/suche/wohnung-mieten/düsseldorf?housingType=1&locationIds%5Bcities%5D=7960"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "düsseldorf",
    path: "/d%C3%BCsseldorf/",
    meta: {"cityPage":{"name":"düsseldorf","countryName":"germany","locationIds":{"regions":[],"cities":[7960],"areas":[]},"searchUrl":"/suche/wohnung-mieten/düsseldorf?housingType=1&locationIds%5Bcities%5D=7960"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "leipzig",
    path: "/leipzig/",
    meta: {"cityPage":{"name":"leipzig","countryName":"germany","locationIds":{"regions":[],"cities":[11685],"areas":[]},"searchUrl":"/suche/wohnung-mieten/leipzig?housingType=1&locationIds%5Bcities%5D=11685"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "dortmund",
    path: "/dortmund/",
    meta: {"cityPage":{"name":"dortmund","countryName":"germany","locationIds":{"regions":[],"cities":[7806],"areas":[]},"searchUrl":"/suche/wohnung-mieten/dortmund?housingType=1&locationIds%5Bcities%5D=7806"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "essen",
    path: "/essen/",
    meta: {"cityPage":{"name":"essen","countryName":"germany","locationIds":{"regions":[],"cities":[7961],"areas":[]},"searchUrl":"/suche/wohnung-mieten/essen?housingType=1&locationIds%5Bcities%5D=7961"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "bremen",
    path: "/bremen/",
    meta: {"cityPage":{"name":"bremen","countryName":"germany","locationIds":{"regions":[],"cities":[4701],"areas":[]},"searchUrl":"/suche/wohnung-mieten/bremen?housingType=1&locationIds%5Bcities%5D=4701"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "dresden",
    path: "/dresden/",
    meta: {"cityPage":{"name":"dresden","countryName":"germany","locationIds":{"regions":[],"cities":[11347],"areas":[]},"searchUrl":"/suche/wohnung-mieten/dresden?housingType=1&locationIds%5Bcities%5D=11347"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "hannover",
    path: "/hannover/",
    meta: {"cityPage":{"name":"hannover","countryName":"germany","locationIds":{"regions":[],"cities":[7060],"areas":[]},"searchUrl":"/suche/wohnung-mieten/hannover?housingType=1&locationIds%5Bcities%5D=7060"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "nuernberg",
    path: "/nuernberg/",
    meta: {"cityPage":{"name":"nürnberg","countryName":"germany","locationIds":{"regions":[],"cities":[1485],"areas":[]},"searchUrl":"/suche/wohnung-mieten/nürnberg?housingType=1&locationIds%5Bcities%5D=1485"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "nürnberg",
    path: "/n%C3%BCrnberg/",
    meta: {"cityPage":{"name":"nürnberg","countryName":"germany","locationIds":{"regions":[],"cities":[1485],"areas":[]},"searchUrl":"/suche/wohnung-mieten/nürnberg?housingType=1&locationIds%5Bcities%5D=1485"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "duisburg",
    path: "/duisburg/",
    meta: {"cityPage":{"name":"duisburg","countryName":"germany","locationIds":{"regions":[],"cities":[7959],"areas":[]},"searchUrl":"/suche/wohnung-mieten/duisburg?housingType=1&locationIds%5Bcities%5D=7959"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "bochum",
    path: "/bochum/",
    meta: {"cityPage":{"name":"bochum","countryName":"germany","locationIds":{"regions":[],"cities":[7805],"areas":[]},"searchUrl":"/suche/wohnung-mieten/bochum?housingType=1&locationIds%5Bcities%5D=7805"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "wuppertal",
    path: "/wuppertal/",
    meta: {"cityPage":{"name":"wuppertal","countryName":"germany","locationIds":{"regions":[],"cities":[8024],"areas":[]},"searchUrl":"/suche/wohnung-mieten/wuppertal?housingType=1&locationIds%5Bcities%5D=8024"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "bielefeld",
    path: "/bielefeld/",
    meta: {"cityPage":{"name":"bielefeld","countryName":"germany","locationIds":{"regions":[],"cities":[7888],"areas":[]},"searchUrl":"/suche/wohnung-mieten/bielefeld?housingType=1&locationIds%5Bcities%5D=7888"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "bonn",
    path: "/bonn/",
    meta: {"cityPage":{"name":"bonn","countryName":"germany","locationIds":{"regions":[],"cities":[8035],"areas":[]},"searchUrl":"/suche/wohnung-mieten/bonn?housingType=1&locationIds%5Bcities%5D=8035"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "muenster",
    path: "/muenster/",
    meta: {"cityPage":{"name":"münster","countryName":"germany","locationIds":{"regions":[],"cities":[8154],"areas":[]},"searchUrl":"/suche/wohnung-mieten/münster?housingType=1&locationIds%5Bcities%5D=8154%2C32507"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "münster",
    path: "/m%C3%BCnster/",
    meta: {"cityPage":{"name":"münster","countryName":"germany","locationIds":{"regions":[],"cities":[8154],"areas":[]},"searchUrl":"/suche/wohnung-mieten/münster?housingType=1&locationIds%5Bcities%5D=8154%2C32507"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "karlsruhe",
    path: "/karlsruhe/",
    meta: {"cityPage":{"name":"karlsruhe","countryName":"germany","locationIds":{"regions":[],"cities":[409],"areas":[]},"searchUrl":"/suche/wohnung-mieten/karlsruhe?housingType=1&locationIds%5Bcities%5D=409"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "mannheim",
    path: "/mannheim/",
    meta: {"cityPage":{"name":"mannheim","countryName":"germany","locationIds":{"regions":[],"cities":[433],"areas":[]},"searchUrl":"/suche/wohnung-mieten/mannheim?housingType=1&locationIds%5Bcities%5D=433"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "augsburg",
    path: "/augsburg/",
    meta: {"cityPage":{"name":"augsburg","countryName":"germany","locationIds":{"regions":[],"cities":[3140],"areas":[]},"searchUrl":"/suche/wohnung-mieten/augsburg?housingType=1&locationIds%5Bcities%5D=3140"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "wiesbaden",
    path: "/wiesbaden/",
    meta: {"cityPage":{"name":"wiesbaden","countryName":"germany","locationIds":{"regions":[],"cities":[4927],"areas":[]},"searchUrl":"/suche/wohnung-mieten/wiesbaden?housingType=1&locationIds%5Bcities%5D=4927"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "gelsenkirchen",
    path: "/gelsenkirchen/",
    meta: {"cityPage":{"name":"gelsenkirchen","countryName":"germany","locationIds":{"regions":[],"cities":[8153],"areas":[]},"searchUrl":"/suche/wohnung-mieten/gelsenkirchen?housingType=1&locationIds%5Bcities%5D=8153"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "braunschweig",
    path: "/braunschweig/",
    meta: {"cityPage":{"name":"braunschweig","countryName":"germany","locationIds":{"regions":[],"cities":[6673],"areas":[]},"searchUrl":"/suche/wohnung-mieten/braunschweig?housingType=1&locationIds%5Bcities%5D=6673"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "kiel",
    path: "/kiel/",
    meta: {"cityPage":{"name":"kiel","countryName":"germany","locationIds":{"regions":[],"cities":[13263],"areas":[]},"searchUrl":"/suche/wohnung-mieten/kiel?housingType=1&locationIds%5Bcities%5D=13263"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "chemnitz",
    path: "/chemnitz/",
    meta: {"cityPage":{"name":"chemnitz","countryName":"germany","locationIds":{"regions":[],"cities":[10943],"areas":[]},"searchUrl":"/suche/wohnung-mieten/chemnitz?housingType=1&locationIds%5Bcities%5D=10943"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "rostock",
    path: "/rostock/",
    meta: {"cityPage":{"name":"rostock","countryName":"germany","locationIds":{"regions":[],"cities":[6358],"areas":[]},"searchUrl":"/suche/wohnung-mieten/rostock?housingType=1&locationIds%5Bcities%5D=6358"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "freiburg-im-breisgau",
    path: "/freiburg-im-breisgau/",
    meta: {"cityPage":{"name":"freiburg im breisgau","countryName":"germany","locationIds":{"regions":[],"cities":[76],"areas":[]},"searchUrl":"/suche/wohnung-mieten/freiburg-im-breisgau?housingType=1&locationIds%5Bcities%5D=76"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "magdeburg",
    path: "/magdeburg/",
    meta: {"cityPage":{"name":"magdeburg","countryName":"germany","locationIds":{"regions":[],"cities":[12465],"areas":[]},"searchUrl":"/suche/wohnung-mieten/magdeburg?housingType=1&locationIds%5Bcities%5D=12465"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "luebeck",
    path: "/luebeck/",
    meta: {"cityPage":{"name":"lübeck","countryName":"germany","locationIds":{"regions":[],"cities":[13265],"areas":[]},"searchUrl":"/suche/wohnung-mieten/lübeck?housingType=1&locationIds%5Bcities%5D=13265"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "lübeck",
    path: "/l%C3%BCbeck/",
    meta: {"cityPage":{"name":"lübeck","countryName":"germany","locationIds":{"regions":[],"cities":[13265],"areas":[]},"searchUrl":"/suche/wohnung-mieten/lübeck?housingType=1&locationIds%5Bcities%5D=13265"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "oldenburg",
    path: "/oldenburg/",
    meta: {"cityPage":{"name":"oldenburg","countryName":"germany","locationIds":{"regions":[],"cities":[7726],"areas":[]},"searchUrl":"/suche/wohnung-mieten/oldenburg?housingType=1&locationIds%5Bcities%5D=7726"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "heidelberg",
    path: "/heidelberg/",
    meta: {"cityPage":{"name":"heidelberg","countryName":"germany","locationIds":{"regions":[],"cities":[393],"areas":[]},"searchUrl":"/suche/wohnung-mieten/heidelberg?housingType=1&locationIds%5Bcities%5D=393"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "mainz",
    path: "/mainz/",
    meta: {"cityPage":{"name":"mainz","countryName":"germany","locationIds":{"regions":[],"cities":[9970],"areas":[]},"searchUrl":"/suche/wohnung-mieten/mainz?housingType=1&locationIds%5Bcities%5D=9970"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "ingolstadt",
    path: "/ingolstadt/",
    meta: {"cityPage":{"name":"ingolstadt","countryName":"germany","locationIds":{"regions":[],"cities":[2173],"areas":[]},"searchUrl":"/suche/wohnung-mieten/ingolstadt?housingType=1&locationIds%5Bcities%5D=2173"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "erfurt",
    path: "/erfurt/",
    meta: {"cityPage":{"name":"erfurt","countryName":"germany","locationIds":{"regions":[],"cities":[14466],"areas":[]},"searchUrl":"/suche/wohnung-mieten/erfurt?housingType=1&locationIds%5Bcities%5D=14466"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "regensburg",
    path: "/regensburg/",
    meta: {"cityPage":{"name":"regensburg","countryName":"germany","locationIds":{"regions":[],"cities":[3035],"areas":[]},"searchUrl":"/suche/wohnung-mieten/regensburg?housingType=1&locationIds%5Bcities%5D=3035"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "potsdam",
    path: "/potsdam/",
    meta: {"cityPage":{"name":"potsdam","countryName":"germany","locationIds":{"regions":[],"cities":[4345],"areas":[]},"searchUrl":"/suche/wohnung-mieten/potsdam?housingType=1&locationIds%5Bcities%5D=4345"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "aachen",
    path: "/aachen/",
    meta: {"cityPage":{"name":"aachen","countryName":"germany","locationIds":{"regions":[],"cities":[8025],"areas":[]},"searchUrl":"/suche/wohnung-mieten/aachen?housingType=1&locationIds%5Bcities%5D=8025"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "salzgitter",
    path: "/salzgitter/",
    meta: {"cityPage":{"name":"salzgitter","countryName":"germany","locationIds":{"regions":[],"cities":[6831],"areas":[]},"searchUrl":"/suche/wohnung-mieten/salzgitter?housingType=1&locationIds%5Bcities%5D=6831"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "darmstadt",
    path: "/darmstadt/",
    meta: {"cityPage":{"name":"darmstadt","countryName":"germany","locationIds":{"regions":[],"cities":[4732],"areas":[]},"searchUrl":"/suche/wohnung-mieten/darmstadt?housingType=1&locationIds%5Bcities%5D=4732"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "erlangen",
    path: "/erlangen/",
    meta: {"cityPage":{"name":"erlangen","countryName":"germany","locationIds":{"regions":[],"cities":[1401],"areas":[]},"searchUrl":"/suche/wohnung-mieten/erlangen?housingType=1&locationIds%5Bcities%5D=1401"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "ulm",
    path: "/ulm/",
    meta: {"cityPage":{"name":"ulm","countryName":"germany","locationIds":{"regions":[],"cities":[1313],"areas":[]},"searchUrl":"/suche/wohnung-mieten/ulm?housingType=1&locationIds%5Bcities%5D=1313"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "offenbach-am-main",
    path: "/offenbach-am-main/",
    meta: {"cityPage":{"name":"offenbach am main","countryName":"germany","locationIds":{"regions":[],"cities":[4872],"areas":[]},"searchUrl":"/suche/wohnung-mieten/offenbach-am-main?housingType=1&locationIds%5Bcities%5D=4872"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "bamberg",
    path: "/bamberg/",
    meta: {"cityPage":{"name":"bamberg","countryName":"germany","locationIds":{"regions":[],"cities":[2636],"areas":[]},"searchUrl":"/suche/wohnung-mieten/bamberg?housingType=1&locationIds%5Bcities%5D=2636"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "heilbronn",
    path: "/heilbronn/",
    meta: {"cityPage":{"name":"heilbronn","countryName":"germany","locationIds":{"regions":[],"cities":[725],"areas":[]},"searchUrl":"/suche/wohnung-mieten/heilbronn?housingType=1&locationIds%5Bcities%5D=725"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "osnabrueck",
    path: "/osnabrueck/",
    meta: {"cityPage":{"name":"osnabrück","countryName":"germany","locationIds":{"regions":[],"cities":[7761],"areas":[]},"searchUrl":"/suche/wohnung-mieten/osnabrück?housingType=1&locationIds%5Bcities%5D=7761"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "osnabrück",
    path: "/osnabr%C3%BCck/",
    meta: {"cityPage":{"name":"osnabrück","countryName":"germany","locationIds":{"regions":[],"cities":[7761],"areas":[]},"searchUrl":"/suche/wohnung-mieten/osnabrück?housingType=1&locationIds%5Bcities%5D=7761"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "trier",
    path: "/trier/",
    meta: {"cityPage":{"name":"trier","countryName":"germany","locationIds":{"regions":[],"cities":[10668],"areas":[]},"searchUrl":"/suche/wohnung-mieten/trier?housingType=1&locationIds%5Bcities%5D=10668"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "wolfsburg",
    path: "/wolfsburg/",
    meta: {"cityPage":{"name":"wolfsburg","countryName":"germany","locationIds":{"regions":[],"cities":[6873],"areas":[]},"searchUrl":"/suche/wohnung-mieten/wolfsburg?housingType=1&locationIds%5Bcities%5D=6873"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "wien",
    path: "/wien/",
    meta: {"cityPage":{"name":"wien","countryName":"austria","locationIds":{"regions":[],"cities":[38113],"areas":[]},"searchUrl":"/suche/wohnung-mieten/wien?housingType=1&locationIds%5Bcities%5D=38113"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "graz",
    path: "/graz/",
    meta: {"cityPage":{"name":"graz","countryName":"austria","locationIds":{"regions":[],"cities":[38115],"areas":[]},"searchUrl":"/suche/wohnung-mieten/graz?housingType=1&locationIds%5Bcities%5D=38115"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "linz",
    path: "/linz/",
    meta: {"cityPage":{"name":"linz","countryName":"austria","locationIds":{"regions":[],"cities":[25214],"areas":[]},"searchUrl":"/suche/wohnung-mieten/linz?housingType=1&locationIds%5Bcities%5D=25214"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "salzburg",
    path: "/salzburg/",
    meta: {"cityPage":{"name":"salzburg","countryName":"austria","locationIds":{"regions":[],"cities":[30847],"areas":[]},"searchUrl":"/suche/wohnung-mieten/salzburg?housingType=1&locationIds%5Bcities%5D=30847"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "innsbruck",
    path: "/innsbruck/",
    meta: {"cityPage":{"name":"innsbruck","countryName":"austria","locationIds":{"regions":[],"cities":[32374],"areas":[]},"searchUrl":"/suche/wohnung-mieten/innsbruck?housingType=1&locationIds%5Bcities%5D=32374"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "klagenfurt",
    path: "/klagenfurt/",
    meta: {"cityPage":{"name":"klagenfurt","countryName":"austria","locationIds":{"regions":[],"cities":[38114],"areas":[]},"searchUrl":"/suche/wohnung-mieten/klagenfurt?housingType=1&locationIds%5Bcities%5D=38114"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "wels",
    path: "/wels/",
    meta: {"cityPage":{"name":"wels","countryName":"austria","locationIds":{"regions":[],"cities":[27465],"areas":[]},"searchUrl":"/suche/wohnung-mieten/wels?housingType=1&locationIds%5Bcities%5D=27465"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "zuerich",
    path: "/zuerich/",
    meta: {"cityPage":{"name":"zürich","countryName":"switzerland","locationIds":{"regions":[],"cities":[15526],"areas":[]},"searchUrl":"/suche/wohnung-mieten/zürich?housingType=1&locationIds%5Bcities%5D=15526"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "zürich",
    path: "/z%C3%BCrich/",
    meta: {"cityPage":{"name":"zürich","countryName":"switzerland","locationIds":{"regions":[],"cities":[15526],"areas":[]},"searchUrl":"/suche/wohnung-mieten/zürich?housingType=1&locationIds%5Bcities%5D=15526"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "genf",
    path: "/genf/",
    meta: {"cityPage":{"name":"genf","countryName":"switzerland","locationIds":{"regions":[],"cities":[17326],"areas":[]},"searchUrl":"/suche/wohnung-mieten/genf?housingType=1&locationIds%5Bcities%5D=17326"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "basel",
    path: "/basel/",
    meta: {"cityPage":{"name":"basel","countryName":"switzerland","locationIds":{"regions":[],"cities":[16143],"areas":[]},"searchUrl":"/suche/wohnung-mieten/basel?housingType=1&locationIds%5Bcities%5D=16143"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "bern",
    path: "/bern/",
    meta: {"cityPage":{"name":"bern","countryName":"switzerland","locationIds":{"regions":[],"cities":[16154],"areas":[]},"searchUrl":"/suche/wohnung-mieten/bern?housingType=1&locationIds%5Bcities%5D=16154"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "lausanne",
    path: "/lausanne/",
    meta: {"cityPage":{"name":"lausanne","countryName":"switzerland","locationIds":{"regions":[],"cities":[19769],"areas":[]},"searchUrl":"/suche/wohnung-mieten/lausanne?housingType=1&locationIds%5Bcities%5D=19769"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "winterthur",
    path: "/winterthur/",
    meta: {"cityPage":{"name":"winterthur","countryName":"switzerland","locationIds":{"regions":[],"cities":[20930],"areas":[]},"searchUrl":"/suche/wohnung-mieten/winterthur?housingType=1&locationIds%5Bcities%5D=20930"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "luzern",
    path: "/luzern/",
    meta: {"cityPage":{"name":"luzern","countryName":"switzerland","locationIds":{"regions":[],"cities":[17928],"areas":[]},"searchUrl":"/suche/wohnung-mieten/luzern?housingType=1&locationIds%5Bcities%5D=17928"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "st.-gallen",
    path: "/st.-gallen/",
    meta: {"cityPage":{"name":"st. gallen","countryName":"switzerland","locationIds":{"regions":[],"cities":[18236],"areas":[]},"searchUrl":"/suche/wohnung-mieten/st.-gallen?housingType=1&locationIds%5Bcities%5D=18236"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  },
  {
    name: "lugano",
    path: "/lugano/",
    meta: {"cityPage":{"name":"lugano","countryName":"switzerland","locationIds":{"regions":[],"cities":[19284],"areas":[]},"searchUrl":"/suche/wohnung-mieten/lugano?housingType=1&locationIds%5Bcities%5D=19284"}},
    component: () => import("/app/browser/modules/city-pages/pages.vue")
  }
]